import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { formatCategoryLabel } from "@/lib/acronyms";
import { isKnownTaxonomyValue, taxonomyKey } from "@/content/taxonomy";

/**
 * Resolves a stored taxonomy slug to a translated label.
 * Unknown values fall back to the acronym-aware title-caser so new data never
 * renders a raw slug.
 */
export function useTaxonomyLabel() {
  const { t } = useTranslation();
  return useCallback(
    (value: string | null | undefined): string => {
      if (!value) return "";
      const fallback = formatCategoryLabel(value);
      if (!isKnownTaxonomyValue(value)) return fallback;
      return t(taxonomyKey(value), { defaultValue: fallback });
    },
    [t],
  );
}
